(function () {
  var forms = document.querySelectorAll(".contact__form");

  if (!forms.length) {
    return;
  }

  forms.forEach(function (form) {
    form.querySelectorAll("[data-select-field]").forEach(function (field) {
      var btn = field.querySelector("[data-select-btn]");
      var label = field.querySelector("[data-select-label]");
      var options = field.querySelectorAll("[data-select-option]");
      var hiddenInput = field.querySelector("[data-select-value]");

      if (!btn || !label) {
        return;
      }

      btn.addEventListener("click", function () {
        var isOpen = field.classList.contains("contact__field--open");

        form.querySelectorAll(".contact__field--open").forEach(function (openField) {
          closeSelect(openField);
        });

        if (!isOpen) {
          openSelect(field, btn);
        }
      });

      options.forEach(function (option) {
        option.addEventListener("click", function () {
          var value = option.getAttribute("data-value") || "";
          var text = option.getAttribute("data-label") || option.textContent.trim();

          label.textContent = text;

          if (hiddenInput) {
            hiddenInput.value = value;
          }

          options.forEach(function (item) {
            item.classList.toggle("is-active", item === option);
            item.setAttribute("aria-selected", item === option ? "true" : "false");
          });

          closeSelect(field);
        });
      });
    });

    form.addEventListener("submit", function (event) {
      var first = form.querySelector("[data-contact-first]");
      var last = form.querySelector("[data-contact-last]");
      var name = form.querySelector("[data-contact-name]");
      var reason = form.querySelector("[data-select-value]");

      if (reason && !reason.value) {
        event.preventDefault();
        var reasonField = form.querySelector("[data-select-field]");
        var reasonBtn = reasonField && reasonField.querySelector("[data-select-btn]");

        if (reasonField && reasonBtn) {
          openSelect(reasonField, reasonBtn);
        }

        return;
      }

      if (!name) {
        return;
      }

      name.value = [first && first.value, last && last.value]
        .filter(Boolean)
        .join(" ")
        .trim();
    });
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-select-field]")) {
      return;
    }

    document.querySelectorAll(".contact__field--open").forEach(function (field) {
      closeSelect(field);
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") {
      return;
    }

    document.querySelectorAll(".contact__field--open").forEach(function (field) {
      closeSelect(field);
    });
  });

  function openSelect(field, btn) {
    field.classList.add("contact__field--open");
    btn.setAttribute("aria-expanded", "true");
  }

  function closeSelect(field) {
    var btn = field.querySelector("[data-select-btn]");

    field.classList.remove("contact__field--open");

    if (btn) {
      btn.setAttribute("aria-expanded", "false");
    }
  }
})();
